import { HStack, Button, Input } from '@chakra-ui/react';

const QuantityInput = ({ value, onChange, min = 0, max, color }) => {
  const handleIncrement = () => {
    // Get current value or use 0 if empty
    const currentValue = value === "" || value === null || value === undefined ? 0 : Number(value);
    const newValue = Math.min(currentValue + 1, max);
    // Only call onChange, not onIncrease (to avoid double increment)
    onChange(newValue);
  };

  const handleDecrement = () => {
    // Get current value or use 0 if empty
    const currentValue = value === "" || value === null || value === undefined ? 0 : Number(value);
    const newValue = Math.max(currentValue - 1, min);
    // Only call onChange, not onDecrease (to avoid double decrement)
    onChange(newValue);
  };

  const handleInputChange = (event) => {
    const inputValue = event.target.value;

    // Allow empty input
    if (inputValue === "") {
      onChange("");
      return;
    }

    // Parse and validate the input
    const numValue = parseInt(inputValue, 10);

    if (!isNaN(numValue)) {
      // Clamp the value between min and max
      const clampedValue = Math.max(min, Math.min(max, numValue));
      onChange(clampedValue);
    }
  };

  const handleInputBlur = () => {
    // If input is empty on blur, set to 0
    if (value === "" || value === null || value === undefined) {
      onChange(0);
    }
  };

  return (
    <HStack minW="170px">
      <Button
        onClick={handleDecrement}
        isDisabled={value <= min}
        size="sm"
      >
        -
      </Button>
      <Input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        variant="outline"
        value={value === 0 ? "" : value}
        onChange={handleInputChange}
        onBlur={handleInputBlur}
        textAlign="center"
        color={color}
        size="sm"
        maxW="80px"
      />
      <Button
        onClick={handleIncrement}
        isDisabled={value >= max}
        size="sm"
      >
        +
      </Button>
    </HStack>
  );
};

export default QuantityInput;
